<ng-container *ngIf="!isOrgLevel; else orgLevelTemp">
    <mat-form-field 
        appearance="outline"
        class="custom-group-selector"
        style="width: 280px"
        [class.mat-form-field-invalid]="!organizationData?.seniorCenters?.length"
    >
        <mat-label>{{ 
            organizationData?.seniorCenters?.length 
                ? (!selectedSeniorCenterData) ? 'Organization' : 'Program(s)' 
                : 'There is no Program(s).' 
        }}</mat-label>

        <mat-select [value]="selectedSeniorCenterData || 0" panelClass="toolbar-option-panel custom-selector">
            <ng-container *ngIf="extraOptions?.length; else centerSelectorOptionsTemp">
                <mat-option 
                    *ngFor="let extraOpt of extraOptions" 
                    (click)="changeValue((extraOpt.value == 0) ? null : extraOpt.value)" 
                    [value]="extraOpt.value" 
                    class="mt-8 mb-0"
                >
                    <span class="custom-selector-option-text">{{extraOpt.name}}</span>
                </mat-option>

                <mat-optgroup [label]="'Program(s)'" *ngIf="organizationData?.seniorCenters?.length">
                        <ng-container *ngFor="let sc of organizationData.seniorCenters">
                            <mat-option (click)="changeValue(sc)" [value]="sc">
                                <span class="custom-selector-option-text">{{ sc.name }}</span>
                            </mat-option>
                        </ng-container>
                </mat-optgroup>
            </ng-container>

            <ng-template #centerSelectorOptionsTemp>
                <ng-container *ngIf="organizationData?.seniorCenters?.length">
                    <ng-container *ngFor="let sc of organizationData.seniorCenters">
                        <mat-option (click)="changeValue(sc)" [value]="sc">
                            <span class="custom-selector-option-text">{{ sc.name }}</span>
                        </mat-option>
                    </ng-container>
                </ng-container>
            </ng-template>
            
        </mat-select>
    </mat-form-field>
</ng-container>

<ng-template #orgLevelTemp>
    <mat-form-field appearance="outline" class="custom-group-selector" style="min-width: 280px">
        <mat-label>{{ selectedSeniorCenterData ? 'Program(s)' : 'Organization' }}</mat-label>

        <mat-select [value]="selectedSeniorCenterData || 0" panelClass="toolbar-option-panel custom-selector">
            <mat-optgroup [label]="'Organization'">
                <mat-option (click)="changeValue(null)" [value]="0">
                    <span class="custom-selector-option-text">{{ organizationData.name }}</span>
                </mat-option>
            </mat-optgroup>

            <ng-container *ngIf="extraOptions?.length">
                <mat-option 
                    *ngFor="let extraOpt of extraOptions" 
                    (click)="changeValue((extraOpt.value == 0) ? null : extraOpt.value)" 
                    [value]="extraOpt.value" 
                    class="mt-8 mb-0"
                >
                    <span class="custom-selector-option-text">{{extraOpt.name}}</span>
                </mat-option>
            </ng-container>

            <mat-optgroup [label]="'Program(s)'" *ngIf="organizationData?.seniorCenters?.length">
                <ng-container *ngFor="let sc of organizationData.seniorCenters">
                    <mat-option (click)="changeValue(sc)" [value]="sc">
                        <span class="custom-selector-option-text">{{ sc.name }}</span>
                    </mat-option>
                </ng-container>
            </mat-optgroup>
        </mat-select>
    </mat-form-field>
</ng-template>